<template>
  <div class="w-full h-full flex flex-col lg:flex-row items-start gap-3">
    <TsCarouselV2
      ref="carouselRef"
      append-class="px-0 min-w-72 max-w-3xl"
      :pagination="false"
      :navigation="false"
    >
      <TsCarouselSlide
        v-for="(item, index) in props.images"
        :key="item.src"
        append-class="flex items-center justify-center lg:p-0"
      >
        <TsImage
          :src="item.src"
          :width="isMobile ? '200' : '400'"
          :height="isMobile ? '200' : '400'"
          loading="lazy"
        />
      </TsCarouselSlide>
    </TsCarouselV2>

    <div class="grow h-full flex flex-col">
      <TsTypography as="h2">
        <span>{{ props.brand }}&nbsp;</span>
        <span>{{ props.title }}</span>
      </TsTypography>
      <div class="overflow-auto max-h-[300px] grow flex flex-wrap gap-3">
        <button
          v-for="(item, index) in props.images"
          :key="index"
          :class="twMerge(
            'h-[80px] w-[80px] flex items-center justify-center border rounded-lg',
            selected_index === index && 'border-primary'
          )"
          @click="onImageClick(index)"
        >
          <TsImage :src="item.thumb" width="60" height="60" loading="lazy" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from "vue";
import { twMerge } from "tailwind-merge";
import { scrollTo, selectedScrollSnap } from "../../utils/carouselUtils";
import TsCarouselV2 from "~/components/organisms/TsCarouselV2.vue";
import TsCarouselSlide from "~/components/organisms/TsCarouselSlide.vue";

type Props = {
  title?: string;
  brand?: string;
  images?: { src: string; thumb: string }[];
  SelectedImage?: string;
};

const props = withDefaults(defineProps<Props>(), {
  brand: "DeWALT",
  title: "DCD791P2-QW cordless drill/driver 18V 5.0Ah Li-ion",
  images: () => [],
});

const { isMobile } = useDevice();
const carouselRef = ref<InstanceType<typeof TsCarouselV2> | null>(null);
const carouselApi = ref<any>(null);

// Directly initializing selected_index
const selected_index = ref(props.images?.findIndex((image) => image.src === props.SelectedImage) ?? 0);

// Handle thumbnail click
const onImageClick = (index: number) => {
  selected_index.value = index; // Update selected index
  if (carouselApi.value) {
    scrollTo(carouselApi, index);
  }
};

// Sync selected image index with carousel
const onSelect = () => {
  if (carouselApi.value) {
    selected_index.value = selectedScrollSnap(carouselApi);
  }
};

onMounted(() => {
  nextTick(() => {
    if (carouselRef.value) {
      carouselApi.value = carouselRef.value?.emblaApi;
      onSelect();
      carouselApi.value?.on("reInit", onSelect).on("select", onSelect);
    }
  });
});
</script>
